import React, { useState } from "react";
import axios from "../api/axiosInstance";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { ChangeLanguage } from "../services/AuthService";
import { useLanguage } from "./LanguageContext";

const logoHaraz = "../HarazIcon64.png";
const logoAlima = "../ALIMA-FA.png";
const logoZago = "../ZAGO-FARSI.png";

const i18n = {
  fa: {
    lang: "fa",
    companyFull: "شرکت فراورده‌های لبنی دوشه آمل",
    tagline: "لبنیات تازه از دامنه‌های البرز",
    pageTitle: "ورود به سامانه سفارش گذاری",
    pageSubtitle: "اطلاعات حساب کاربری خود را وارد کنید",
    usernamePlaceholder: "نام کاربری",
    passwordPlaceholder: "رمز عبور",
    loginBtn: "ورود",
    loggingIn: "در حال ورود...",
    errorMsg: "خطا در ورود. لطفاً دوباره تلاش کنید.",
    copyright: "© ۱۴۰۵ شرکت فراورده‌های لبنی دوشه آمل — تمامی حقوق محفوظ است",
    switchLang: "العربية",
    hidePass: "پنهان کردن رمز",
    showPass: "نمایش رمز",
    badgeText: "سامانه فروش اختصاصی",
  },
  ar: {
    lang: "ar",
    companyFull: "شركة منتجات الألبان دوشه آمل",
    tagline: "منتجات الألبان الطازجة من سفوح البرز",
    pageTitle: "قم بتسجيل الدخول إلى نظام الطلبات",
    pageSubtitle: "أدخل بيانات حسابك للمتابعة",
    usernamePlaceholder: "اسم المستخدم",
    passwordPlaceholder: "كلمة المرور",
    loginBtn: "دخول",
    loggingIn: "جارٍ تسجيل الدخول...",
    errorMsg: "حدث خطأ أثناء تسجيل الدخول. يرجى المحاولة مرة أخرى.",
    copyright: "© ٢٠٢٦ شركة هراز لمنتجات الألبان — جميع الحقوق محفوظة",
    switchLang: "فارسی",
    hidePass: "إخفاء كلمة المرور",
    showPass: "إظهار كلمة المرور",
    badgeText: "بوابة المبيعات الرسمية",
  },
};

const LoginPage = () => {
  const { lang, setLang } = useLanguage(); // به‌جای useState محلی
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const t = i18n[lang];

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!username.trim() || !password.trim()) return;
    setIsLoading(true);
    try {
      const { data } = await axios.post("/Auth/login", {
        UserName: username,
        PasswordHash: password,
      });

      if (data.token) {
        localStorage.setItem("token", data.token);
        localStorage.setItem("userName", username);
        // localStorage زبان قبلاً توسط setLang در Context آپدیت شده

        try {
          await ChangeLanguage({
            UserName: username,
            PasswordHash: password,
            Language: lang, // همین lang از Context، که با کلیک دکمه زبان به‌روز شده
          });
        } catch (langErr) {
          console.error("خطا در ذخیره زبان:", langErr);
        }

        navigate("/dashboard");
      } else {
        alert(data);
      }
    } catch {
      Swal.fire({
        icon: "error",
        title: lang === "fa" ? "خطا" : "خطأ",
        text: t.errorMsg,
        showCloseButton: true,
      });
    } finally {
      setIsLoading(false);
    }
  };


 const handleLangSwitch = () => {
    const newLang = lang === "fa" ? "ar" : "fa";
    setLang(newLang); // این الان از Context میاد و همه‌جا اعمال می‌شه
  };

  return (
    <>
      {isLoading && (
        <div style={s.overlay}>
          <div style={s.spinner} />
        </div>
      )}

      <style>{`
        * { box-sizing: border-box; margin: 0; padding: 0; }

        @keyframes spin { to { transform: rotate(360deg); } }

        .lp-root {
          display: flex;
          flex-direction: row;
          min-height: 100vh;
          width: 100%;
          font-family: 'IRANSansWeb', 'Vazirmatn', 'Tajawal', Arial, sans-serif;
          background: #4677a0;
          overflow: hidden;
        }

        .lp-right {
          width: 50%;
          flex-shrink: 0;
          display: flex;
          flex-direction: column;
           align-items: center;
          justify-content: center;
          padding: 40px 24px;
          position: relative;
          background: #4677a0;
        }

        .lp-left {
          width: 50%;
          flex-shrink: 0;
          margin: 20px 0 20px 20px;
          border-radius: 20px;
          background-image: url('../ChatGPT Image Jun 23 2026 02_03_27 PM.png');
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
          position: relative;
          overflow: hidden;
          box-shadow: 0 8px 40px rgba(0,0,0,0.35);
        }
        .lp-left-overlay {
          position: absolute;
          inset: 0;
          background: rgba(20,60,40,0.40);
        }
        .lp-left-content {
          position: relative;
          z-index: 1;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: flex-end;
          height: 100%;
          padding: 40px 32px;
          text-align: center;
          color: #fff;
        }
        .lp-left-title {
          font-size: clamp(18px, 2vw, 26px);
          font-weight: 700;
          color: #c8f0d8;
          line-height: 1.8;
          margin-bottom: 8px;
        }
        .lp-left-tagline {
          font-size: clamp(12px, 1.2vw, 15px);
          color: rgba(255,255,255,0.72);
          line-height: 1.8;
        }
        .lp-badge {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          background: rgba(82,183,136,0.28);
          border: 0.5px solid rgba(82,183,136,0.55);
          border-radius: 20px;
          padding: 5px 18px;
          font-size: 13px;
          color: rgba(255,255,255,0.9);
          margin-top: 14px;
        }

        .lp-card {
         width: 100%;
         max-width: 500px;
         background: #234d6e;
         border-radius: 18px;
         border: 0.5px solid rgba(255,255,255,0.18);
         padding: 48px 36px 60px;
         display: flex;
         flex-direction: column;
         align-items: center;
         height: fit-content;  
        }

        .lp-logo-row {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          gap: 20px;
          margin-bottom: 22px;
          flex-wrap: wrap;
        }
        .lp-logo {
          max-height: 52px;
          max-width: 90px;
          width: auto;
          height: auto;
          object-fit: contain;
          display: block;
        }

        .lp-title {
          font-size: clamp(16px, 1.8vw, 20px);
          font-weight: 700;
          color: #e8f4ff;
          margin-bottom: 6px;
          text-align: center;
        }
        .lp-sub {
          font-size: 12px;
          color: rgba(255,255,255,0.62);
          margin-bottom: 18px;
          text-align: center;
          line-height: 1.7;
        }

        .lp-form {
          width: 100%;
          display: flex;
          flex-direction: column;
          gap: 10px;
        }

        .lp-input-wrap { position: relative; width: 100%; }
        .lp-icon-right {
          position: absolute;
          right: 13px;
          top: 50%;
          transform: translateY(-50%);
          display: flex;
          align-items: center;
          pointer-events: none;
        }
        .lp-input {
          width: 100%;
          height: 48px;
          border: 1px solid rgba(255,255,255,0.22);
          border-radius: 10px;
          background: rgba(255,255,255,0.1);
          font-size: 15px;
          color: #e8f4ff;
          padding-right: 44px;
          padding-left: 44px;
          text-align: right;
          font-family: 'IRANSansWeb', 'Vazirmatn', 'Tajawal', Arial, sans-serif;
          transition: border-color 0.15s, box-shadow 0.15s;
        }
        .lp-input::placeholder { color: rgba(255,255,255,0.42); }
        .lp-input:focus {
          border-color: #52b788 !important;
          box-shadow: 0 0 0 3px rgba(82,183,136,0.18) !important;
          outline: none;
        }

        .lp-eye {
          position: absolute;
          left: 12px;
          top: 50%;
          transform: translateY(-50%);
          background: none;
          border: none;
          cursor: pointer;
          padding: 3px;
          display: flex;
          align-items: center;
        }

        .lp-submit {
          width: 100%;
          height: 48px;
          background: #52b788;
          color: #fff;
          border: none;
          border-radius: 10px;
          font-size: 15px;
          font-weight: 700;
          font-family: 'Calibri', 'Vazirmatn', 'Tajawal', Arial, sans-serif;
          margin-top: 4px;
          transition: background 0.15s, transform 0.1s;
          cursor: pointer;
        }
        .lp-submit:hover:not(:disabled) { background: #40916c; }
        .lp-submit:active:not(:disabled) { transform: scale(0.98); }
        .lp-submit:disabled { opacity: 0.5; cursor: not-allowed; }

        .lp-copyright {
          margin-top: 14px;
          font-size: 10px;
          color: rgba(255,255,255,0.42);
          text-align: center;
          line-height: 1.8;
        }

        .lp-lang {
          position: absolute;
          top: 22px;
          right: 22px;
          display: flex;
          align-items: center;
          gap: 6px;
          background: rgba(255,255,255,0.12);
          border: 0.5px solid rgba(255,255,255,0.28);
          border-radius: 8px;
          padding: 7px 13px;
          font-size: 13px;
          font-weight: 500;
          color: rgba(255,255,255,0.9);
          cursor: pointer;
          font-family: inherit;
          transition: background 0.15s;
        }
        .lp-lang:hover { background: rgba(255,255,255,0.2); }

        @media (max-width: 900px) {
          .lp-left { display: none; }

          .lp-right {
            width: 100%;
            padding: 40px 48px;
            min-height: 100vh;
          }

          .lp-card {
              width: 100%;
              max-width: 360px;
              background: #234d6e;
              border-radius: 18px;
              border: 0.5px solid rgba(255,255,255,0.18);
              padding: 48px 36px 60px;
              display: flex;
              flex-direction: column;
              align-items: center;
              height: fit-content;
            }
        }

        @media (max-width: 540px) {
          .lp-right { padding: 32px 16px; }

          .lp-card { padding: 28px 18px 24px; border-radius: 14px; }

          .lp-logo { max-height: 42px; max-width: 70px; }
          .lp-logo-row { gap: 14px; margin-bottom: 16px; }

          .lp-title { font-size: 15px; }
          .lp-sub { font-size: 12px; margin-bottom: 20px; }

          .lp-input, .lp-submit { height: 48px; font-size: 14px; }

          .lp-lang { top: 14px; right: 14px; font-size: 12px; padding: 6px 10px; }
        }

        @media (max-width: 360px) {
          .lp-card { padding: 22px 14px 20px; }
          .lp-logo-row { gap: 10px; }
        }
      `}</style>

      <div className="lp-root" dir="rtl" lang={t.lang}>

        <div className="lp-right">
          <button className="lp-lang" onClick={handleLangSwitch} aria-label="تغییر زبان">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <circle cx="12" cy="12" r="10" />
              <path d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
            </svg>
            {t.switchLang}
          </button>

          <div className="lp-card">
            <div className="lp-logo-row">
              <img src={logoHaraz} alt="هراز" className="lp-logo" />
              <img src={logoAlima} alt="آلیما" className="lp-logo" />
              <img src={logoZago} alt="زاگو" className="lp-logo" />
            </div>
            <h1 className="lp-title">{t.pageTitle}</h1>
            <p className="lp-sub">{t.pageSubtitle}</p>

            <form onSubmit={handleLogin} className="lp-form" noValidate>
              <div className="lp-input-wrap">
                <span className="lp-icon-right" aria-hidden="true">
                  <svg width="17" height="17" viewBox="0 0 24 24" fill="none"
                    stroke="rgba(30,70,100,0.75)" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                    <circle cx="12" cy="7" r="4" />
                  </svg>
                </span>
                <input className="lp-input" type="text" value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  placeholder={t.usernamePlaceholder}
                  autoComplete="username" required aria-label={t.usernamePlaceholder} />
              </div>

              <div className="lp-input-wrap">
                <span className="lp-icon-right" aria-hidden="true">
                  <svg width="17" height="17" viewBox="0 0 24 24" fill="none"
                    stroke="rgba(30,70,100,0.75)" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                  </svg>
                </span>
                <input className="lp-input" type={showPassword ? "text" : "password"}
                  value={password} onChange={(e) => setPassword(e.target.value)}
                  placeholder={t.passwordPlaceholder}
                  autoComplete="current-password" required aria-label={t.passwordPlaceholder} />
                <button type="button" onClick={() => setShowPassword((v) => !v)}
                  className="lp-eye" aria-label={showPassword ? t.hidePass : t.showPass}>
                  {showPassword ? (
                    <svg width="17" height="17" viewBox="0 0 24 24" fill="none"
                      stroke="rgba(100,140,170,0.85)" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" />
                      <line x1="1" y1="1" x2="23" y2="23" />
                    </svg>
                  ) : (
                    <svg width="17" height="17" viewBox="0 0 24 24" fill="none"
                      stroke="rgba(30,70,100,0.75)" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                      <circle cx="12" cy="12" r="3" />
                    </svg>
                  )}
                </button>
              </div>

              <button type="submit" className="lp-submit"
                disabled={isLoading || !username || !password}>
                {isLoading ? t.loggingIn : t.loginBtn}
              </button>
            </form>

            <p className="lp-copyright">{t.copyright}</p>
          </div>
        </div>

        <div className="lp-left">
          <div className="lp-left-overlay" />
        </div>

      </div>
    </>
  );
};

const s = {
  overlay: {
    position: "fixed", inset: 0,
    background: "rgba(0,0,0,0.45)",
    zIndex: 9999,
    display: "flex", alignItems: "center", justifyContent: "center",
  },
  spinner: {
    width: 50, height: 50,
    border: "5px solid rgba(255,255,255,0.25)",
    borderTopColor: "#fff",
    borderRadius: "50%",
    animation: "spin 0.8s linear infinite",
  },
};

export default LoginPage;